import { z } from 'zod'
import { oc } from '@orpc/contract'

export const discardScribeSessionResponseSchema = z.object({
  discarded: z.boolean(),
})
export type DiscardScribeSessionResponse = z.infer<typeof discardScribeSessionResponseSchema>

export const scribeDiscardSession = oc
  .route({ method: 'DELETE', path: '/v2/scribe/sessions/{encounterId}/{sessionId}' })
  .input(z.object({ encounterId: z.string(), sessionId: z.string() }))
  .output(discardScribeSessionResponseSchema)
